import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

const API = process.env.REACT_APP_BACKEND_URL;

export const MaintenancePanel = () => {
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/maintenance`)
      .then(({ data }) => { setEnabled(data.enabled); setMessage(data.message); setLoaded(true); })
      .catch(() => setStatus("Couldn't load maintenance settings. Refresh to try again."));
  }, []);

  const save = async (nextEnabled = enabled) => {
    setSaving(true);
    setStatus("");
    try {
      const { data } = await axios.put(`${API}/api/admin/maintenance`, { enabled: nextEnabled, message });
      setEnabled(data.enabled);
      setMessage(data.message);
      setStatus(data.enabled ? "Store is CLOSED to customers." : "Store is OPEN to customers.");
      window.dispatchEvent(new Event("maintenance-changed"));
    } catch (e) {
      setStatus(e.response?.data?.detail || "Save failed.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`mb-10 p-5 border ${enabled ? "border-[#39FF14]/50 bg-[#39FF14]/5" : "border-[#1A1A1A]"}`} data-testid="maintenance-panel">
      <div className="flex items-center justify-between gap-4 mb-4">
        <div>
          <h2 className="font-mono uppercase tracking-[0.2em] text-xs font-bold text-[#39FF14]">Maintenance Mode</h2>
          <p className="text-[#A1A1A1] text-xs mt-1">When on, customers only see a "back soon" page. Admins can still use everything.</p>
        </div>
        <Switch checked={enabled} disabled={saving || !loaded} onCheckedChange={(v) => save(v)} data-testid="maintenance-toggle" />
      </div>
      <label className="font-mono uppercase tracking-[0.15em] text-[10px] font-bold text-[#A1A1A1]">Message shown to customers</label>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={2}
        maxLength={500}
        disabled={!loaded}
        className="w-full mt-1 mb-3 bg-[#0D0D0D] border border-[#1A1A1A] text-[#F2F2F2] rounded-none focus:border-[#39FF14] focus:outline-none px-3 py-2 text-sm font-mono resize-none"
        data-testid="maintenance-message-input"
      />
      <div className="flex items-center gap-3">
        <Button onClick={() => save()} disabled={saving || !loaded} variant="outline" className="bg-transparent border-[#39FF14]/40 text-[#39FF14] rounded-none font-mono text-[10px] uppercase tracking-wider" data-testid="maintenance-save">
          Save Message
        </Button>
        {status && <span className="font-mono text-[11px] text-[#F2F2F2]" data-testid="maintenance-status">{status}</span>}
      </div>
    </div>
  );
};
